import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { DataSharingService } from '../../../core/services/data-sharing.service';

@Component({
  selector: 'app-content-drawer',
  templateUrl: './content-drawer.component.html',
  styleUrls: ['./content-drawer.component.scss'],
})
export class ContentDrawerComponent implements OnInit {
  @Input() type = '';
  @Input() descriptions: any = [];
  @Input() activities: any = [];
  @Input() attractions: any = [];
  @Input() selectedItemIds: any = [];
  filteredDescriptions: any = [];
  filteredActivities: any = [];
  filteredAttractions: any = [];
  disableSelectItemIds: any = [];
  keyword = '';
  title = '';
  placeholderPath: any = '../assets/img/placeholder-image.png';

  constructor(
    private nzDrawerRef: NzDrawerRef,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this.filteredDescriptions = this.descriptions;
    this.filteredActivities = this.activities;
    this.filteredAttractions = this.attractions;
    this.disableSelectItemIds = this.selectedItemIds;
    switch (this.type) {
      case 'DESTINATION':
        this.title = 'Destination';
        break;
      case 'CITY':
        this.title = 'City';
        break;
      case 'ACTIVITIES':
        this.title = 'Activities';
        break;
      case 'ATTRACTIONS':
        this.title = 'Attractions';
        break;
    }
  }

  closeWithData(data?: any): void {
    switch (this.type) {
      case 'DESTINATION':
        this.nzDrawerRef.close({
          description: data,
          type: this.type,
        });
        break;
      case 'CITY':
        this.nzDrawerRef.close({
          description: data,
          type: this.type,
        });
        break;
      case 'ACTIVITIES':
        this.disableSelectItemIds.push(data._id);
        this.dataSharingService.setSharedData({
          activity: data,
          type: this.type,
        });
        break;
      case 'ATTRACTIONS':
        this.nzDrawerRef.close({
          attraction: data,
          type: this.type,
        });
    }
  }
  close(): void {
    this.nzDrawerRef.close();
  }

  searchDescriptions(): void {
    this.filteredDescriptions = this.descriptions.filter((val: string) => {
      return val.toLowerCase().indexOf(this.keyword.toLowerCase()) !== -1;
    });
  }

  searchActivities(): void {
    this.filteredActivities = this.activities.filter((val: any) => {
      return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) !== -1;
    });
  }

  searchAttractions(): void {
    this.filteredAttractions = this.attractions.filter((val: any) => {
      return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) !== -1;
    });
  }

  isFullWidth(a: any): string {
    if (a?.image) {
      return 'col-span-8';
    }
    return 'col-span-12';
  }
}
